// extracted by mini-css-extract-plugin
export default {"headBanner":"zrSFS","rowsSpacing":"Nc5W6","userRequest":"RMmMW","offer":"QC9e4","buttonsBlock":"DecDu","endDate":"gR2mx","scheduledText":"gG2D1","rejectedText":"BXWDm"};